import { createContainer } from 'react-sweet-state';

import { type Actions, ComplianceStore, type State } from './ComplianceStore';

type ContainerProps = {
  state: Partial<State>;
};

export const ComplianceStoreContainer = createContainer<State, Actions, ContainerProps>(
  ComplianceStore,
  {
    onInit:
      () =>
      ({ setState }, { state }) => {
        if (state) {
          setState(state);
        }
      },
    onUpdate:
      () =>
      ({ setState }, { state }) => {
        if (state) {
          setState(state);
        }
      },
  }
);
